import { assortmentApi as assortmentNewApi } from '@autone/redux/assortment';
import { coreApiNext } from '@autone/redux/core';
import { dataIngestionApi } from '@autone/redux/data-ingestion';
import { coreApi, userApi, userReducer } from '@autone/ui';
import { configureStore } from '@reduxjs/toolkit';

import { assortmentApi } from './assortment';

export const createStore = () =>
  configureStore({
    reducer: {
      [userApi.reducerPath]: userApi.reducer,
      [assortmentApi.reducerPath]: assortmentApi.reducer,
      [assortmentNewApi.reducerPath]: assortmentNewApi.reducer,
      [coreApi.reducerPath]: coreApi.reducer,
      [coreApiNext.reducerPath]: coreApiNext.reducer,
      [dataIngestionApi.reducerPath]: dataIngestionApi.reducer,
      user: userReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(assortmentApi.middleware)
        .concat(assortmentNewApi.middleware)
        .concat(userApi.middleware)
        .concat(coreApi.middleware)
        .concat(coreApiNext.middleware)
        .concat(dataIngestionApi.middleware),
  });

const store = createStore();

export default store;
